module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-04.c966cd45.png";